import React, { useEffect } from "react";
import PeriButton from "../Components/Button";
import background2 from "../../../assets/vietnam/landing-page3-bg2.png"

import '../style/peri-check.css'
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const LandingPage3 = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation("l3")

    // useEffect(() => {
    //     setTimeout(() => {
    //         navigate("/peri-gum/scan")
    //     }, 3500)

    // }, [])

    return (
        <div className="w-full h-screen flex flex-col overflow-hidden">

            <div className="background-image1 p-2">
                <div className="w-full mt-4 p-8 flex flex-col justify-evenly">
                    <p className="text-peri-secondary text-2xl mt-2 font-bold font-cera-pro-black">
                        {t("header1")} <span className="text-peri-primary">{t("header2")}</span>
                    </p>

                    {i18n.language === "vn" && (
                        <p className="font-cera-pro-medium text-peri-blue mt-4 mb-3 text-base font-semibold">
                            *Theo Hội Răng Hàm Mặt Việt Nam
                        </p>
                    )}

                    <p className="text-peri-secondary mt-4 font-cera-pro-medium font-[800]">
                        {t("body1")}<span className="text-peri-primary"> {t("body2")} </span>{t("body3")}
                    </p>

                    <div className={`w-full flex justify-center ${i18n.language === "vn" ? `mt-4` : `mt-8`}`}>
                        <PeriButton text={t("callToAction")} onClick={() =>
                            navigate(i18n.language === "bs" ? "/peri-gum/landing-page-3" : "/peri-gum/scan")
                        } />
                    </div>
                </div>
            </div>

            <div
                className="flex-1 bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${background2})` }}
            />
        </div>

    );
};

export default LandingPage3;
